export class Zone {
  id: bigint;
  zone_name: string;
  zone_desc: string;
  lager_zone: string;
}
